import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { showPopupNew } from '../../actions/popup-actions';
import { PopupTypes } from '../../utils/constants';
import { getClickAttrs } from '../Analytics/gtag';
import { PowerFunnelSurfaces, PowerFunnelGatedFeatures } from '../Analytics/constants';

const UpgradeToPowerLinkV2 = (props) => {
    const { className, location, 'data-testid': dataTestId } = props;
    const dispatch = useDispatch();
    const history = useHistory();
    const auth = useSelector(({ auth }) => auth);

    const handleClick = () => {
        if (auth.user?.hasPastDueSubscription) {
            history.push('/subscriptions');
        } else {
            dispatch(showPopupNew({
                popup: PopupTypes.POWER_UPGRADE_POPUP,
                referringSurface: PowerFunnelSurfaces.SEARCH_FOOTER,
                gatedFeature: PowerFunnelGatedFeatures.SEARCH_RESULTS,
            }));
        }
    };
    return (
        <span
            className={className}
            onClick={handleClick}
            data-testid={dataTestId}
            {...getClickAttrs({
                category: 'Power Upgrade',
                context: `Upgrade To Power Click - ${location}`,
                location,
            })}
        >
            {auth.user?.hasPastDueSubscription ? 'Resume Power' : 'Upgrade to Power'}
        </span>
    );
};

UpgradeToPowerLinkV2.propTypes = {
    className: PropTypes.string,
    location: PropTypes.string,
    'data-testid': PropTypes.string,
};

UpgradeToPowerLinkV2.defaultProps = {
    className: '',
    location: '',
    'data-testid': undefined,
};

export default UpgradeToPowerLinkV2;
